import _toConsumableArray from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _createForOfIteratorHelper from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _asyncToGenerator from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

import { proxy as p, subscribe as C } from "valtio/vanilla";
import { Buffer as $ } from "buffer";
var M;
var m = {
  ethereumClient: void 0,
  setEthereumClient: function setEthereumClient(e) {
    M = e;
  },
  client: function client() {
    if (M) return M;
    throw new Error("ClientCtrl has no client set");
  }
},
    i = p({
  history: ["ConnectWallet"],
  view: "ConnectWallet",
  data: void 0
}),
    f = {
  state: i,
  subscribe: function subscribe(e) {
    return C(i, function () {
      return e(i);
    });
  },
  push: function push(e, t) {
    e !== i.view && (i.view = e, t && (i.data = t), i.history.push(e));
  },
  reset: function reset(e) {
    i.view = e, i.history = [e];
  },
  replace: function replace(e) {
    i.history.length > 1 && (i.history[i.history.length - 1] = e, i.view = e);
  },
  goBack: function goBack() {
    if (i.history.length > 1) {
      i.history.pop();

      var _i$history$slice = i.history.slice(-1),
          _i$history$slice2 = _slicedToArray(_i$history$slice, 1),
          e = _i$history$slice2[0];

      i.view = e;
    }
  },
  setData: function setData(e) {
    i.data = e;
  }
},
    c = {
  WALLETCONNECT_DEEPLINK_CHOICE: "WALLETCONNECT_DEEPLINK_CHOICE",
  W3M_VERSION: "W3M_VERSION",
  RECOMMENDED_WALLET_AMOUNT: 9,
  isMobile: function isMobile() {
    return typeof window < "u" ? !!(window.matchMedia("(pointer:coarse)").matches || /Android|webOS|iPhone|iPad|iPod|BlackBerry|Opera Mini/.test(navigator.userAgent)) : !1;
  },
  isAndroid: function isAndroid() {
    return c.isMobile() && navigator.userAgent.toLowerCase().includes("android");
  },
  isIos: function isIos() {
    var e = navigator.userAgent.toLowerCase();
    return c.isMobile() && (e.includes("iphone") || e.includes("ipad"));
  },
  isHttpUrl: function isHttpUrl(e) {
    return e.startsWith("http://") || e.startsWith("https://");
  },
  isArray: function isArray(e) {
    return Array.isArray(e) && e.length > 0;
  },
  formatNativeUrl: function formatNativeUrl(e, t, n) {
    if (c.isHttpUrl(e)) return this.formatUniversalUrl(e, t, n);
    var s = e;
    s.includes("://") || (s = e.replaceAll("/", "").replaceAll(":", ""), s = "".concat(s, "://")), this.setWalletConnectDeepLink(s, n);
    var a = encodeURIComponent(t);
    return "".concat(s, "wc?uri=").concat(a);
  },
  formatUniversalUrl: function formatUniversalUrl(e, t, n) {
    if (!c.isHttpUrl(e)) return this.formatNativeUrl(e, t, n);
    var s = e;
    e.endsWith("/") && (s = e.slice(0, -1)), this.setWalletConnectDeepLink(s, n);
    var a = encodeURIComponent(t);
    return "".concat(s, "/wc?uri=").concat(a);
  },
  wait: function wait(e) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", new Promise(function (t) {
                setTimeout(t, e);
              }));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  openHref: function openHref(e, t) {
    window.open(e, t, "noreferrer noopener");
  },
  setWalletConnectDeepLink: function setWalletConnectDeepLink(e, t) {
    localStorage.setItem(c.WALLETCONNECT_DEEPLINK_CHOICE, JSON.stringify({
      href: e,
      name: t
    }));
  },
  setWalletConnectAndroidDeepLink: function setWalletConnectAndroidDeepLink(e) {
    var _e$split = e.split("?"),
        _e$split2 = _slicedToArray(_e$split, 1),
        t = _e$split2[0];

    localStorage.setItem(c.WALLETCONNECT_DEEPLINK_CHOICE, JSON.stringify({
      href: t,
      name: "Android"
    }));
  },
  setWeb3ModalVersionInStorage: function setWeb3ModalVersionInStorage() {
    typeof localStorage < "u" && localStorage.setItem(c.W3M_VERSION, "2.3.6");
  },
  getWalletRouterData: function getWalletRouterData() {
    var e;
    var t = (e = f.state.data) == null ? void 0 : e.Wallet;
    if (!t) throw new Error('Missing "Wallet" view data');
    return t;
  },
  getSwitchNetworkRouterData: function getSwitchNetworkRouterData() {
    var e;
    var t = (e = f.state.data) == null ? void 0 : e.SwitchNetwork;
    if (!t) throw new Error('Missing "SwitchNetwork" view data');
    return t;
  }
},
    r = p({
  selectedChain: void 0,
  chains: void 0,
  standaloneChains: void 0,
  standaloneUri: void 0,
  isStandalone: !1,
  isCustomDesktop: !1,
  isCustomMobile: !1,
  isDataLoaded: !1,
  isUiLoaded: !1,
  isInjectedMobile: !1,
  walletConnectVersion: 1
}),
    d = {
  state: r,
  subscribe: function subscribe(e) {
    return C(r, function () {
      return e(r);
    });
  },
  setChains: function setChains(e) {
    r.chains = e;
  },
  setStandaloneChains: function setStandaloneChains(e) {
    r.standaloneChains = e;
  },
  setStandaloneUri: function setStandaloneUri(e) {
    r.standaloneUri = e;
  },
  getSelectedChain: function getSelectedChain() {
    var e = m.client().getNetwork().chain;
    return e && (r.selectedChain = e), r.selectedChain;
  },
  setSelectedChain: function setSelectedChain(e) {
    r.selectedChain = e;
  },
  setIsStandalone: function setIsStandalone(e) {
    r.isStandalone = e;
  },
  setIsCustomDesktop: function setIsCustomDesktop(e) {
    r.isCustomDesktop = e;
  },
  setIsCustomMobile: function setIsCustomMobile(e) {
    r.isCustomMobile = e;
  },
  setIsDataLoaded: function setIsDataLoaded(e) {
    r.isDataLoaded = e;
  },
  setIsUiLoaded: function setIsUiLoaded(e) {
    r.isUiLoaded = e;
  },
  setWalletConnectVersion: function setWalletConnectVersion(e) {
    r.walletConnectVersion = e;
  },
  setIsInjectedMobile: function setIsInjectedMobile(e) {
    r.isInjectedMobile = e;
  }
},
    O = p({
  projectId: "",
  mobileWallets: void 0,
  desktopWallets: void 0,
  walletImages: void 0,
  chainImages: void 0,
  tokenImages: void 0,
  tokenContracts: void 0,
  standaloneChains: void 0,
  enableStandaloneMode: !1,
  enableNetworkView: !1,
  enableAccountView: !0,
  enableExplorer: !0,
  defaultChain: void 0,
  explorerExcludedWalletIds: void 0,
  explorerRecommendedWalletIds: void 0,
  termsOfServiceUrl: void 0,
  privacyPolicyUrl: void 0
}),
    b = {
  state: O,
  subscribe: function subscribe(e) {
    return C(O, function () {
      return e(O);
    });
  },
  setConfig: function setConfig(e) {
    var t, n, s, a;
    d.setStandaloneChains(e.standaloneChains), d.setIsStandalone(!!((t = e.standaloneChains) != null && t.length) || !!e.enableStandaloneMode), d.setIsCustomMobile(!!((n = e.mobileWallets) != null && n.length)), d.setIsCustomDesktop(!!((s = e.desktopWallets) != null && s.length)), d.setWalletConnectVersion((a = e.walletConnectVersion) != null ? a : 1), d.state.isStandalone || (d.setChains(m.client().chains), d.setIsInjectedMobile(c.isMobile() && m.client().isInjectedProviderInstalled())), e.defaultChain && d.setSelectedChain(e.defaultChain), c.setWeb3ModalVersionInStorage(), Object.assign(O, e);
  }
},
    o = p({
  address: void 0,
  profileName: void 0,
  profileAvatar: void 0,
  profileLoading: !1,
  balanceLoading: !1,
  balance: void 0,
  isConnected: !1
}),
    V = {
  state: o,
  subscribe: function subscribe(e) {
    return C(o, function () {
      return e(o);
    });
  },
  getAccount: function getAccount() {
    var e = m.client().getAccount();
    o.address = e.address, o.isConnected = e.isConnected;
  },
  fetchProfile: function fetchProfile(e, t) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var n, s, a, _yield$Promise$all, _yield$Promise$all2, l, u;

      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              o.profileLoading = !0;
              s = t !== null && t !== void 0 ? t : o.address, a = (n = d.state.chains) == null ? void 0 : n.find(function (l) {
                return l.id === 1;
              });

              if (!(s && a)) {
                _context2.next = 16;
                break;
              }

              _context2.next = 6;
              return Promise.all([m.client().fetchEnsName({
                address: s,
                chainId: 1
              }), m.client().fetchEnsAvatar({
                address: s,
                chainId: 1
              })]);

            case 6:
              _yield$Promise$all = _context2.sent;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
              l = _yield$Promise$all2[0];
              u = _yield$Promise$all2[1];
              _context2.t0 = u;

              if (!_context2.t0) {
                _context2.next = 14;
                break;
              }

              _context2.next = 14;
              return e(u);

            case 14:
              o.profileName = l;
              o.profileAvatar = u;

            case 16:
              _context2.prev = 16;
              o.profileLoading = !1;
              return _context2.finish(16);

            case 19:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0,, 16, 19]]);
    }))();
  },
  fetchBalance: function fetchBalance(e) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var _m$client$getNetwork, t, n, s, a, l;

      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _m$client$getNetwork = m.client().getNetwork(), t = _m$client$getNetwork.chain, n = b.state.tokenContracts;
              t && n && (s = n[t.id]), o.balanceLoading = !0;
              a = e !== null && e !== void 0 ? e : o.address;

              if (!a) {
                _context3.next = 9;
                break;
              }

              _context3.next = 7;
              return m.client().fetchBalance({
                address: a,
                token: s
              });

            case 7:
              l = _context3.sent;
              o.balance = {
                amount: l.formatted,
                symbol: l.symbol
              };

            case 9:
              _context3.prev = 9;
              o.balanceLoading = !1;
              return _context3.finish(9);

            case 12:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0,, 9, 12]]);
    }))();
  },
  setAddress: function setAddress(e) {
    o.address = e;
  },
  setIsConnected: function setIsConnected(e) {
    o.isConnected = e;
  },
  resetBalance: function resetBalance() {
    o.balance = void 0;
  },
  resetAccount: function resetAccount() {
    o.address = void 0, o.isConnected = !1, o.profileName = void 0, o.profileAvatar = void 0, o.balance = void 0;
  }
},
    S = "https://explorer-api.walletconnect.com";

function j(_x, _x2) {
  return _j.apply(this, arguments);
}

function _j() {
  _j = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12(e, t) {
    var n;
    return _regeneratorRuntime().wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            n = new URL(e, S);
            n.searchParams.append("projectId", b.state.projectId);
            Object.entries(t).forEach(function (_ref3) {
              var _ref4 = _slicedToArray(_ref3, 2),
                  s = _ref4[0],
                  a = _ref4[1];

              a && n.searchParams.append(s, String(a));
            });
            _context12.next = 5;
            return fetch(n);

          case 5:
            return _context12.abrupt("return", _context12.sent.json());

          case 6:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));
  return _j.apply(this, arguments);
}

var h = {
  getDesktopListings: function getDesktopListings(e) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", j("/w3m/v1/getDesktopListings", e));

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }))();
  },
  getMobileListings: function getMobileListings(e) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt("return", j("/w3m/v1/getMobileListings", e));

            case 1:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }))();
  },
  getInjectedListings: function getInjectedListings(e) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt("return", j("/w3m/v1/getInjectedListings", e));

            case 1:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }))();
  },
  getAllListings: function getAllListings(e) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt("return", j("/w3m/v1/getAllListings", e));

            case 1:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }))();
  },
  getWalletImageUrl: function getWalletImageUrl(e) {
    return "".concat(S, "/w3m/v1/getWalletImage/").concat(e, "?projectId=").concat(b.state.projectId);
  },
  getAssetImageUrl: function getAssetImageUrl(e) {
    return "".concat(S, "/w3m/v1/getAssetImage/").concat(e, "?projectId=").concat(b.state.projectId);
  }
};

var R = Object.defineProperty,
    U = Object.getOwnPropertySymbols,
    _ = Object.prototype.hasOwnProperty,
    B = Object.prototype.propertyIsEnumerable,
    N = function N(e, t, n) {
  return t in e ? R(e, t, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: n
  }) : e[t] = n;
},
    H = function H(e, t) {
  for (var n in t || (t = {})) {
    _.call(t, n) && N(e, n, t[n]);
  }

  if (U) {
    var _iterator = _createForOfIteratorHelper(U(t)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var n = _step.value;
        B.call(t, n) && N(e, n, t[n]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return e;
};

var k = c.isMobile(),
    g = p({
  wallets: {
    listings: [],
    total: 0,
    page: 1
  },
  injectedWallets: [],
  search: {
    listings: [],
    total: 0,
    page: 1
  },
  recomendedWallets: []
}),
    X = {
  state: g,
  getRecomendedWallets: function getRecomendedWallets() {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
      var _b$state, e, t, n, _yield$h$getAllListin, s, a, _d$state, _n, _s, _a, l, u, _ref, v;

      return _regeneratorRuntime().wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _b$state = b.state, e = _b$state.explorerRecommendedWalletIds, t = _b$state.explorerExcludedWalletIds;

              if (!(e === "NONE" || t === "ALL" && !e)) {
                _context8.next = 3;
                break;
              }

              return _context8.abrupt("return", g.recomendedWallets);

            case 3:
              if (!c.isArray(e)) {
                _context8.next = 13;
                break;
              }

              n = {
                recommendedIds: e.join(",")
              };
              _context8.next = 7;
              return h.getAllListings(n);

            case 7:
              _yield$h$getAllListin = _context8.sent;
              s = _yield$h$getAllListin.listings;
              a = Object.values(s);
              a.sort(function (l, u) {
                var v = e.indexOf(l.id),
                    I = e.indexOf(u.id);
                return v - I;
              }), g.recomendedWallets = a;
              _context8.next = 31;
              break;

            case 13:
              _d$state = d.state;
              _n = _d$state.standaloneChains;
              _s = _d$state.walletConnectVersion;
              _a = _n === null || _n === void 0 ? void 0 : _n.join(",");
              l = c.isArray(t);
              u = {
                page: 1,
                entries: c.RECOMMENDED_WALLET_AMOUNT,
                chains: _a,
                version: _s,
                excludedIds: l ? t.join(",") : void 0
              };

              if (!k) {
                _context8.next = 25;
                break;
              }

              _context8.next = 22;
              return h.getMobileListings(u);

            case 22:
              _context8.t0 = _context8.sent;
              _context8.next = 28;
              break;

            case 25:
              _context8.next = 27;
              return h.getDesktopListings(u);

            case 27:
              _context8.t0 = _context8.sent;

            case 28:
              _ref = _context8.t0;
              v = _ref.listings;
              g.recomendedWallets = Object.values(v);

            case 31:
              return _context8.abrupt("return", g.recomendedWallets);

            case 32:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }))();
  },
  getWallets: function getWallets(e) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
      var t, _b$state2, n, s, a, l, u, _ref2, v, I, y, A;

      return _regeneratorRuntime().wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              t = H({}, e), _b$state2 = b.state, n = _b$state2.explorerRecommendedWalletIds, s = _b$state2.explorerExcludedWalletIds, a = g.recomendedWallets;

              if (!(s === "ALL")) {
                _context9.next = 3;
                break;
              }

              return _context9.abrupt("return", g.wallets);

            case 3:
              t.search || (a.length ? t.excludedIds = a.map(function (T) {
                return T.id;
              }).join(",") : c.isArray(n) && (t.excludedIds = n.join(","))), c.isArray(s) && (t.excludedIds = [t.excludedIds, s].filter(Boolean).join(","));
              l = e.page;
              u = e.search;

              if (!k) {
                _context9.next = 12;
                break;
              }

              _context9.next = 9;
              return h.getMobileListings(t);

            case 9:
              _context9.t0 = _context9.sent;
              _context9.next = 15;
              break;

            case 12:
              _context9.next = 14;
              return h.getDesktopListings(t);

            case 14:
              _context9.t0 = _context9.sent;

            case 15:
              _ref2 = _context9.t0;
              v = _ref2.listings;
              I = _ref2.total;
              y = Object.values(v);
              A = u ? "search" : "wallets";
              return _context9.abrupt("return", (g[A] = {
                listings: [].concat(_toConsumableArray(g[A].listings), y),
                total: I,
                page: l !== null && l !== void 0 ? l : 1
              }, {
                listings: y,
                total: I
              }));

            case 21:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }))();
  },
  getInjectedWallets: function getInjectedWallets() {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
      var _yield$h$getInjectedL, e, t;

      return _regeneratorRuntime().wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return h.getInjectedListings({});

            case 2:
              _yield$h$getInjectedL = _context10.sent;
              e = _yield$h$getInjectedL.listings;
              t = Object.values(e);
              return _context10.abrupt("return", (g.injectedWallets = t, g.injectedWallets));

            case 6:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }))();
  },
  getWalletImageUrl: function getWalletImageUrl(e) {
    return h.getWalletImageUrl(e);
  },
  getAssetImageUrl: function getAssetImageUrl(e) {
    return h.getAssetImageUrl(e);
  },
  resetSearch: function resetSearch() {
    g.search = {
      listings: [],
      total: 0,
      page: 1
    };
  }
},
    W = p({
  pairingUri: "",
  pairingError: !1
}),
    D = {
  state: W,
  subscribe: function subscribe(e) {
    return C(W, function () {
      return e(W);
    });
  },
  setPairingUri: function setPairingUri(e) {
    W.pairingUri = e;
  },
  setPairingError: function setPairingError(e) {
    W.pairingError = e;
  }
},
    L = p({
  open: !1
}),
    Y = {
  state: L,
  subscribe: function subscribe(e) {
    return C(L, function () {
      return e(L);
    });
  },
  open: function open(e) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
      return _regeneratorRuntime().wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              return _context11.abrupt("return", new Promise(function (t) {
                var _d$state2 = d.state,
                    n = _d$state2.isStandalone,
                    s = _d$state2.isUiLoaded,
                    a = _d$state2.isDataLoaded,
                    l = D.state.pairingUri,
                    u = V.state.isConnected,
                    v = b.state.enableNetworkView;
                if (n ? (d.setStandaloneUri(e === null || e === void 0 ? void 0 : e.uri), d.setStandaloneChains(e === null || e === void 0 ? void 0 : e.standaloneChains), f.reset("ConnectWallet")) : e != null && e.route ? f.reset(e.route) : u ? f.reset("Account") : v ? f.reset("SelectNetwork") : f.reset("ConnectWallet"), s && a && (n || l || u)) L.open = !0, t();else {
                  var I = setInterval(function () {
                    var y = d.state,
                        A = D.state;
                    y.isUiLoaded && y.isDataLoaded && (y.isStandalone || A.pairingUri || u) && (clearInterval(I), L.open = !0, t());
                  }, 200);
                }
              }));

            case 1:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11);
    }))();
  },
  close: function close() {
    L.open = !1;
  }
};

var K = Object.defineProperty,
    x = Object.getOwnPropertySymbols,
    J = Object.prototype.hasOwnProperty,
    q = Object.prototype.propertyIsEnumerable,
    P = function P(e, t, n) {
  return t in e ? K(e, t, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: n
  }) : e[t] = n;
},
    z = function z(e, t) {
  for (var n in t || (t = {})) {
    J.call(t, n) && P(e, n, t[n]);
  }

  if (x) {
    var _iterator2 = _createForOfIteratorHelper(x(t)),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var n = _step2.value;
        q.call(t, n) && P(e, n, t[n]);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return e;
};

function F() {
  return typeof matchMedia < "u" && matchMedia("(prefers-color-scheme: dark)").matches;
}

var E = p({
  themeMode: F() ? "dark" : "light"
}),
    Z = {
  state: E,
  subscribe: function subscribe(e) {
    return C(E, function () {
      return e(E);
    });
  },
  setThemeConfig: function setThemeConfig(e) {
    var t = e.themeMode,
        n = e.themeVariables;
    t && (E.themeMode = t), n && (E.themeVariables = z({}, n));
  }
},
    w = p({
  open: !1,
  message: "",
  variant: "success"
}),
    ee = {
  state: w,
  subscribe: function subscribe(e) {
    return C(w, function () {
      return e(w);
    });
  },
  openToast: function openToast(e, t) {
    w.open = !0, w.message = e, w.variant = t;
  },
  closeToast: function closeToast() {
    w.open = !1;
  }
};
typeof window < "u" && (window.Buffer || (window.Buffer = $), window.global || (window.global = window), window.process || (window.process = {
  env: {}
}));
export { V as AccountCtrl, m as ClientCtrl, b as ConfigCtrl, c as CoreUtil, X as ExplorerCtrl, Y as ModalCtrl, d as OptionsCtrl, f as RouterCtrl, Z as ThemeCtrl, ee as ToastCtrl, D as WcConnectionCtrl };